import styled from "styled-components";
export const Section = styled.section `
  margin: 24px 0;
`;
export const SectionHeading = styled.h2 `
  font-size: 20px;
  margin: 0 0 16px;
`;
export const Paragraph = styled.p `
  margin: 16px 0 0;
`;
